/**
 * Заголовки и описания страниц — в одном месте.
 *
 * Их читают двое: страница в браузере (`usePageMeta`) и скрипт перерисовки,
 * который вписывает те же значения в готовый HTML на этапе сборки. Если бы
 * тексты лежали только в компонентах, в файле для поисковика остался бы
 * заголовок-заглушка из index.html.
 */
import { COURSES } from '../pages/CoursePage';

export interface RouteMeta {
  title: string;
  description: string;
}

export const LANDING_META: RouteMeta = {
  title: 'FREEDOM BIKER — мотошкола в Алматы, обучение вождению мотоцикла',
  description:
    'Обучение вождению мотоцикла в Алматы: занятия один на один с инструктором ' +
    'на площадке, категории A и A1. С нуля, после перерыва и для подготовки к экзамену.',
};

export const SCHEDULE_META: RouteMeta = {
  title: 'Расписание занятий — мотошкола FREEDOM BIKER в Алматы',
  description:
    'Свободное время инструкторов на ближайшие недели. Выберите день и час ' +
    'занятия на мотоцикле — записаться можно без регистрации.',
};

/** Адреса, которые имеет смысл отдавать готовым HTML. */
export const PRERENDER_ROUTES = ['/', ...COURSES.map((course) => `/${course.slug}`)];

export function metaFor(path: string): RouteMeta {
  if (path === '/') return LANDING_META;
  if (path === '/schedule') return SCHEDULE_META;

  const course = COURSES.find((item) => `/${item.slug}` === path);
  if (course) return { title: course.metaTitle, description: course.metaDescription };

  return LANDING_META;
}
